"use client";

import { type ValidationRule } from "@unreserved/types";

import { InfoWarningIcon } from "@/app/_components/icons/info-warning";

interface PasswordValidationRulesProps {
  password: string;
  rules: ValidationRule[];
  touched?: boolean;
}

export const PasswordValidationRules = ({
  password,
  rules,
  touched = false,
}: PasswordValidationRulesProps) => {
  // Only show rules that are not met and only if the field has been touched
  if (!touched) return null;

  const failedRules = rules.filter((rule) => !rule.validate(password));

  // Don't show anything if all rules are met
  if (failedRules.length === 0) return null;

  return (
    <div className="mt-2 space-y-1">
      {failedRules.map((rule) => (
        <div key={rule.id} className="flex items-center gap-1.5">
          <InfoWarningIcon width={13} height={13} className="text-error-600 flex-shrink-0" />
          <p className="text-error-600 text-sm">{rule.label}</p>
        </div>
      ))}
    </div>
  );
};
